import { useState } from 'react';
import UseCasesDashboard from './UseCaseDashboard';
import TaxonomieDashboard from './TaxonomieDashboard';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('usecases');

  const tabStyle = (isActive) => ({
    padding: "16px 32px",
    background: isActive ? "var(--primary-coral)" : "var(--light-gray)",
    color: isActive ? "var(--white)" : "var(--text-dark)",
    border: "none",
    borderRadius: "12px 12px 0 0",
    cursor: "pointer",
    fontWeight: "600",
    fontSize: "16px",
    transition: "var(--transition)",
    marginRight: "4px"
  });

  return (
    <div style={{ 
      minHeight: "calc(100vh - 88px)",
      background: "var(--light-gray)"
    }}>
      {/* Tab Navigation */}
      <div style={{ 
        padding: "16px 24px 0",
        background: "var(--light-gray)"
      }}>
        <div style={{ display: "flex", gap: "4px" }}>
          <button
            style={tabStyle(activeTab === 'usecases')}
            onClick={() => setActiveTab('usecases')}
          >
            📋 Use Cases
          </button>
          <button
            style={tabStyle(activeTab === 'taxonomie')}
            onClick={() => setActiveTab('taxonomie')}
          >
            🏷️ Taxonomien
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div style={{
        background: "var(--white)",
        margin: "0 16px 16px",
        borderRadius: "0 12px 12px 12px",
        boxShadow: "var(--shadow)",
        minHeight: "600px"
      }}>
        {activeTab === 'usecases' && <UseCasesDashboard />}
        {activeTab === 'taxonomie' && <TaxonomieDashboard />}
      </div>
    </div>
  );
};

export default Dashboard; 